import React from "react";

const MissonStatement = () => {
  return (
    <div style={{ width: "90%" }}>
      <h3 style={{ fontSize: "22px" }}>Misson Statement</h3>
      <p style={{ fontSize: "15px" }}>
        We are focused on blockchain projects driving global adoption and
        technological innovation. We take a decentralized, community oriented
        approach to identifying disruptive opportunities through a transparent
        and collaborative research process and long-term focused investment
        framework.
      </p>
    </div>
  );
};

export default MissonStatement;
